<template>
  <div class="headerAddress">
    <div @click="clickHandler">
      <i class="iconfont icon-weizhi-icon" />
      <span>{{ defaultCity ? defaultCity : "添加地区信息" }}</span>
    </div>
    <addLocationDialog
      :row-data="rowData"
      :add-location-show="addLocationShow"
      @dialogCloseHandle="dialogCloseHandle"
      @submitSuccess="addLocationSuccess"
    />
  </div>
</template>

<script>
import addLocationDialog from './addLocationDialog';
import { locationManagementApi } from '../../service';
export default {
  data () {
    return {
      defaultCity: '',
      addLocationShow: false,
      rowData: {}
    };
  },
  components: {
    addLocationDialog
  },
  methods: {
    clickHandler () {
      let { goodsAddress } = this.$store.state;
      if (goodsAddress && Object.keys(goodsAddress).length > 0) {
        this.rowData = JSON.parse(JSON.stringify(goodsAddress));
      }
      this.addLocationShow = true;
    },
    addLocationSuccess (data) {
      // this.$store.commit('setGoodsAddress', data);
      // this.defaultCity = data.city;
      this.addLocationShow = false;
      // this.$emit('addressChange');
      // if (!data.id)
      this.getDefaultAddress();
    },
    dialogCloseHandle () {
      this.addLocationShow = false;
    },
    getDefaultAddress () {
      // let { goodsAddress } = this.$store.state.goodsAddress;
      // if (goodsAddress && Object.keys(goodsAddress).length > 0 && goodsAddress.id) {
      //   this.defaultCity = this.$store.state.goodsAddress.city;
      //   return;
      // }
      locationManagementApi.getAddressList().then(res => {
        if (res.status === '200') {
          // 全部地址
          let allAddress = res.data;
          // 默认出货地址
          let defaultAddress = res.data.filter(item => {
            return item.isDefault;
          });
          // 如果有默认地址，则取默认地址
          if (defaultAddress.length > 0) {
            this.$store.commit('setGoodsAddress', defaultAddress[0]);
            this.$emit('addressChange');
          } else if (allAddress.length > 0) {
            this.$store.commit('setGoodsAddress', allAddress[0]);
            this.$emit('addressChange');
          } else {
            this.addLocationShow = true;
          }
          if (allAddress.length > 0) {
            if (!this.$store.state.goodsAddress.countryType) {
            this.defaultCity = this.$store.state.goodsAddress.city;
            } else {
              this.defaultCity = this.$store.state.goodsAddress.country;
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.headerAddress {
  > div {
    font-size: 16px;
    cursor: pointer;
    position: relative;
    > i {
      margin-right: 8px;
      color: #ffffff;
    }
    > span {
      color: #ffffff;
    }
  }
}
</style>
